import React from 'react';
import { Link } from 'react-router-dom';
import { SOURCE_URL } from '../../../../config';
import language from '../../../../utils/LanguageSettings';
import translations from '../../../../text/get-started-translations.json';

const SlideBarArticles: React.FC<{ slideBarArticles: any[], type: string }> = ({ slideBarArticles, type }) => {
  const pageTranslations = translations[language];
  if(!slideBarArticles || slideBarArticles.length === 0) 
    return null;
  return (
    <div className="side-sections pt-5">
      {type === "categoryHotPickArticles" ? <h3>{pageTranslations.HotTopics}</h3> : <h3>{pageTranslations.LastetUpdate}</h3>}
      {slideBarArticles.map((slideBarArticle) => (
        <Link key={slideBarArticle.id} to={`/blog/${slideBarArticle.attributes.slug}`} className="side-article">
          <img src={slideBarArticle?.attributes?.FeaturedImage?.data?.attributes?.formats?.small?.url ? SOURCE_URL + slideBarArticle.attributes.FeaturedImage.data.attributes.formats.small.url : ''} alt="" />
          <h5 className="title">{slideBarArticle.attributes.Title}</h5>
        </Link>
      ))}
    </div>
  );
};

export default SlideBarArticles;